<template>
	<div
		class="panel"
		:class="[
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div
			class="container"
			:class="[
				isBrand? 'sk' : '',
			]"
		>
			<div v-if="isHeaderVisible" class="panel_header">
				<h2>
					{{ block.block_title }}
				</h2>
				<div v-if="block.description" v-html="block.description" class="description"></div>
			</div>
			<div class="row">
				<div class="col-12 col-lg-6">
					<div
						v-if="block.description_left"
						class="title"
						v-html="block.description_left"
					/>
				</div>
				<div class="col-12 col-lg-6">
					<div
						v-if="block.description_right"
						class="description"
						v-html="block.description_right"
					/>
				</div>
			</div>
			<!--
					Бывает еще подвал, реагирует на соответствующую опцию
					Блоки бывают с репитерами и слайдерами
					Пример с фото и репитерами components\panels\TE\PanelSimilarColumns.vue На беке найдешь.
					Чтобы работал слайдер в репитере реализацию смотрим тут components\panels\LI\PanelLi01.vue
			<div v-if="isFooterVisible" class="panel_footer">

			</div>
			-->
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'DraftHeading1',
	mixins: [panel],
};
</script>
<!-- Стиль  из верстки не зыбываем -->
<style lang="scss" scoped>
	@import "~/assets/styles/components/dev/draft-heading-1";
</style>
